module.exports = __webpack_public_path__ + "static/media/emo3a.d14227c9.png";